module.exports = __webpack_public_path__ + "img/30f3.4c9b389e.jpg";